module.exports = __webpack_public_path__ + "media/nugget-carousel-trans.0c10a47c.wav";